import { Spinner, Text } from '@chakra-ui/react';
import React from 'react';
import Card from '../../Card';

const GoalsCreatedThisMonth = ({ personal, loading }) => {
  return (
    <Card
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
    >
      <Text fontWeight={'bold'} fontSize="sm" w="full">
        Goals Created this Month
      </Text>
      {loading ? (
        <Spinner color="primary" mt={'2'} />
      ) : (
        <Text
          fontWeight={'bold'}
          textAlign={'right'}
          color="primary"
          fontSize="2xl"
          w="full"
          mt={'2'}
        >
          {personal?.goal_created_count || 0}
        </Text>
      )}
    </Card>
  );
};

export default GoalsCreatedThisMonth;
